import { render, staticRenderFns } from "./recommendPage.vue?vue&type=template&id=f57e0e9e&scoped=true&"
import script from "./recommendPage.vue?vue&type=script&lang=js&"
export * from "./recommendPage.vue?vue&type=script&lang=js&"
import style0 from "./recommendPage.vue?vue&type=style&index=0&id=f57e0e9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57e0e9e",
  null
  
)

export default component.exports